document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-arrows-scroll]').forEach(el => {
    const container = document.getElementById(el.dataset.arrowsScroll);

    const scrollBy = multiplier => {
      container.scrollBy({
        left: multiplier * (container.children[1].offsetLeft - container.children[0].offsetLeft),
        behavior: 'smooth'
      });
    };

    el.children[0].addEventListener('click', () => scrollBy(-1));
    el.children[1].addEventListener('click', () => scrollBy(1));

    const disableButtons = () => {
      el.children[0].disabled = container.scrollLeft <= 2;
      el.children[1].disabled = container.scrollLeft >= container.scrollWidth - container.offsetWidth - 2;
      el.hidden = el.children[0].disabled && el.children[1].disabled;
    };
    container.addEventListener('scroll', disableButtons);
    window.addEventListener('resize', disableButtons);
    window.addEventListener('load', disableButtons);
  })
});
